const HilightIcon = ({ width = "40px", height = "40px", fill="#FFCE00" }) => {
    return (
        <svg x="0px" y="0px" viewBox="0 0 40 40" xmlSpace="preserve" width={width} height={height} fill={fill}>
            <polygon points="20,1 26.2,13.5 40,15.5 30,25.3 32.4,39 20,32.5 7.6,39 10,25.3 0,15.5 13.8,13.5 "/>
        </svg>
    );
};

export default HilightIcon;